module.exports = "/img/14.0b4992.webp";